import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { observer } from 'mobx-react';
import { match } from '../../../../utils/patternMatchUtil';
import Text from '../Text';
import Bool from '../Bool';
import DateTime from '../DateTime';
import Select from '../Select';
import Numeric from '../Numeric';
import Breaker from '../Breaker';
import Documents from '../Documents';
export var QuestionRenderer = observer(function QuestionRenderer(props) {
  var Editor = match(props.question.type, _defineProperty({
    TEXT: function TEXT() {
      return Text;
    },
    BOOL: function BOOL() {
      return Bool;
    },
    NUMERIC: function NUMERIC() {
      return Numeric;
    },
    SELECT: function SELECT() {
      return Select;
    },
    BREAKER: function BREAKER() {
      return Breaker;
    },
    DATE_TIME: function DATE_TIME() {
      return DateTime;
    },
    DOCUMENTS: function DOCUMENTS() {
      return Documents;
    }
  }, match.DEFAULT, function () {
    return Text;
  }));
  return /*#__PURE__*/React.createElement(Editor, props);
});
//# sourceMappingURL=index.js.map
